"use client";

import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface SearchResultsListProps {
  /**
   * Child result groups or items
   */
  children: ReactNode;
  /**
   * Maximum height of the results list
   * @default "400px"
   */
  maxHeight?: string;
  /**
   * Additional CSS classes
   */
  className?: string;
}

/**
 * SearchResultsList
 *
 * Container for search results with scrolling and styling.
 * Typically contains SearchResultGroup components.
 *
 * @example
 * ```tsx
 * <SearchResultsList>
 *   <SearchResultGroup title="Sites" count={3}>
 *     <SearchResultItem id="1" title="HQ" />
 *   </SearchResultGroup>
 *   <SearchResultGroup title="Devices" count={2}>
 *     <SearchResultItem id="2" title="Battery" />
 *   </SearchResultGroup>
 * </SearchResultsList>
 * ```
 */
export function SearchResultsList({ children, maxHeight = "400px", className }: SearchResultsListProps) {
  return (
    <div
      className={twMerge("overflow-y-auto overscroll-contain", "divide-y divide-border-muted", className)}
      style={{ maxHeight }}
    >
      {children}
    </div>
  );
}
